import React from 'react';
import * as Icons from 'lucide-react';

/**
 * Composant LucideIcon
 * @param {string} name - Nom de l'icône Lucide (ex: "User", "Search", etc.)
 * @param {number} size - Taille de l'icône
 * @param {string} color - Couleur de l'icône
 * @param {object} props - Autres props (className, strokeWidth, etc.)
 */
const LucideIcon = ({ name, size = 22, color = 'currentColor', ...props }) => {
  const IconComponent = Icons[name];

  if (!IconComponent) {
    console.warn(`L'icône "${name}" n'existe pas dans lucide-react.${Icons}`);
    return null;
  }

  return <IconComponent size={size} color={color} strokeWidth={'1.3'} {...props} />;
};

export default LucideIcon;
